import React from "react";
import * as Ons from "react-onsenui";
import { STRINGS } from "../strings";
import { langMap, translate } from "../translate";

interface Props {
  isOpen: boolean;
  languages: string[];
  onChoose: (language: string) => void;
  onCancel: () => void;
}

const LanguageOptions = (props: Props) => {
  return (
    <Ons.ActionSheet isOpen={props.isOpen} onCancel={props.onCancel}>
      {props.languages.map((language) => (
        <Ons.ActionSheetButton key={language} onClick={() => props.onChoose(language)}>
          {langMap[language]}
        </Ons.ActionSheetButton>
      ))}

      <Ons.ActionSheetButton onClick={props.onCancel}>
        {translate(STRINGS.CANCEL)}
      </Ons.ActionSheetButton>
    </Ons.ActionSheet>
  );
};

export default React.memo(LanguageOptions);
